<template>
    <div class="position-relative">
      <input
        class="form-control"
        :list="listId"
        :id="inputId"
        v-model="inputValue"
        :placeholder="placeholder"
        ref="inputField"
        :disabled="disabled"
      />
      <button v-if="inputValue" @click="clearInput" class="btn-clear">
        &times;
      </button>
      <datalist :id="listId">
        <option v-for="item in items" :key="item.id" :value="item.name"></option>
      </datalist>
    </div>
  </template>
  
  <script>
  export default {
    name: "ClearableInput",
    props: {
      inputId: {
        type: String,
        required: true
      },
      listId: {
        type: String,
        required: true
      },
      items: {
        // type: Array,
        required: true
      },
      placeholder: {
        type: String,
        default: "Type to search..."
      },
      value: {
        type: String,
        default: ""
      },
      disabled: {
        type: Boolean,
        default: false
      }
    },
    computed: {
      inputValue: {
        get() {
          return this.value;
        },
        set(value) {
          this.$emit("input", value);
        }
      }
    },
    methods: {
      clearInput() {
        this.inputValue = "";
        this.$nextTick(() => {
            this.$refs.inputField.focus();
        });
      }
    }
  };
  </script>
  
  <style scoped>
    .position-relative {
      position: relative;
    }
    .btn-clear {
      position: absolute;
      top: 50%;
      right: 10px;
      transform: translateY(-50%);
      border: none;
      background: transparent;
      color: #000;
      font-size: 1.2rem;
      cursor: pointer;
      outline: none;
    }
    .btn-clear:focus {
      box-shadow: none;
    }
  </style>
  